import React, { Component, PropTypes } from 'react';
import { Form,Layout ,Row, Col } from 'antd';
import NHFormItem from "../common/NHFormItem";
import NHFetch from "../../utils/NHFetch";
import css from  './index.css';
import ColStudents from "./RowStudents";

const { Header, Footer, Sider, Content } = Layout;


export default class ShowTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
              xszp:undefined,
        }
    }
    componentWillMount () {
        // let params = {pkid : this.props.showData.XSID};
        // NHFetch('/newStudent/getImgByPkid', 'POST', params)
        // .then(res => {
        //         if (res) {
        //             if (res.data){
        //                     this.setState({
        //                         xszp : res.data,
        //                     }); 
        //             }
                    
        //         }
        // });
    }
    render() {
        let formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
        };
        const {showData}  = this.props;

        return (
            <div>
                <Row>
                    <Col span={16}>
                        <div>
                            <Row>
                                <Col span={12}>
                                    <ColStudents name={"年度"} param={showData.ND}/>
                                </Col>
                                <Col span={12}>
                                    <ColStudents name={"姓名"} param={showData.XM}/>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={12}>
                                    <ColStudents name={"性别"} param={showData.XB}/>
                                </Col>
                                <Col span={12}>
                                    <ColStudents name={"入学年份"} param={showData.RXNF}/>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={12}>
                                    <ColStudents name={"身份证件类型"} param={showData.SFZJLX}/>
                                </Col>
                                <Col span={12}>
                                    <ColStudents name={"身份证件号"} param={showData.SFZJH}/>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col span={8}>
                        <div style={{height:162}}>
                              <Row >
                                    <Col span={9} className={css.photo_left}></Col>
                                    <Col span={15} className={css.photo_right}>
                                    <img style={{width:136,height:160}} src={'api/sm-student/openapi/getStudentPhoto?xsid=' + showData.XSID+'&type=10'} />
                                    </Col>
                              </Row>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col span={8}>
                        <ColStudents name={"考生号"} param={showData.KSH}/>
                    </Col>
                    <Col span={8}>
                        <ColStudents name={"学号"} param={showData.XH}/>
                    </Col>
                    <Col span={8}>
                        <ColStudents name={"录取号"} param={showData.LQH}/>
                    </Col>
                </Row>
                <Row>
                    <Col span={8}>
                        <ColStudents name={"准考证号"} param={showData.ZKZH}/>
                    </Col>
                    <Col span={8}>
                        <ColStudents name={"QQ"} param={showData.QQ}/>
                    </Col>
                    <Col span={8}>
                        <ColStudents name={"微信"} param={showData.WX}/>
                    </Col>
                </Row>
                <Row>
                    <Col span={8}>
                        <ColStudents name={"邮箱"} param={showData.YX}/>
                    </Col>
                    <Col span={8}>
                        <ColStudents name={"出生日期"} param={showData.CSRQ}/>
                    </Col>
                    <Col span={8}>
                        <ColStudents name={"校区"} param={showData.XQMC}/>
                    </Col>
                </Row>
                <Row>
                    <Col span={8}>
                        <ColStudents name={"院系"} param={showData.BMMC}/>
                    </Col>
                    <Col span={8}>
                        <ColStudents name={"专业"} param={showData.ZYMC}/>
                    </Col>
                    <Col span={8}>
                        <ColStudents name={"班级"} param={showData.BJMC}/>
                    </Col>
                </Row>
                <Row>
                    <Col span={8}>
                        <ColStudents name={"手机号码"} param={showData.SJHM}/>
                    </Col>
                    <Col span={8}>
                        <ColStudents name={"政治面貌"} param={showData.ZZMM}/>
                    </Col>
                    <Col span={8}>
                        <ColStudents name={"民族"} param={showData.MZ}/>
                    </Col>
                </Row>
                
                <Row>
                    <Col span={8}>
                        <ColStudents name={"籍贯"} param={showData.JG}/>
                    </Col>
                    <Col span={8}>
                        <ColStudents name={"生源地"} param={showData.SYD}/>
                    </Col>
                    <Col span={8}>
                        <ColStudents name={"学生类型"} param={showData.XSLB}/>
                    </Col>
                </Row>
                <Row>
                    <Col span={8}>
                        <ColStudents name={"学生来源"} param={showData.XSLY}/>
                    </Col>
                    <Col span={8}>
                        <ColStudents name={"高考成绩"} param={showData.GKCJ}/>
                    </Col>
                    
                    <Col span={8}>
                        <ColStudents name={"户口性质"} param={showData.HKXZ}/>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <ColStudents span={[3,21.5]} hieght={100} name={"家庭地址"} param={showData.JTDZ}/>
                    </Col>
                </Row>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./components/newStudentMng/show.js